import React from "react";
import { useLocation } from "react-router-dom";

const PAGE_META = {
  "/home": { title: "Dashboard", subtitle: "Sales, credit & stock" },
  "/customers": { title: "Customers", subtitle: "Balances & accounts" },
  "/stocks": { title: "Stock", subtitle: "Inventory items" },
  "/lager": { title: "Lager", subtitle: "Add customer, driver & item" },
  "/sales": { title: "Sales", subtitle: "Transaction history" },
  "/loans": { title: "Loan", subtitle: "Given & received" },
  "/salary": { title: "Salary", subtitle: "Staff payments" },
  "/expenses": { title: "Expenses", subtitle: "Business spending" },
  "/history": { title: "History", subtitle: "Removed & hidden records" },
  "/list": { title: "List", subtitle: "Customer, driver & item" },
};

export default function PageHeader() {
  const { pathname } = useLocation();
  const meta = PAGE_META[pathname];

  if (!meta) return null;

  return (
    <header className="app-page-header">
      <h1 className="app-page-header__title">{meta.title}</h1>
      {meta.subtitle ? (
        <p className="app-page-header__subtitle">{meta.subtitle}</p>
      ) : null}
    </header>
  );
}
